export type ScriptParameters = {
  [key: string]: string
};

export type UserInfoResult = {
  lastname   : string,
  firstname  : string,
  email      : string,
  fingerprint: string
}

export type CssuaUserAgent = {
  desktop: string,
  mobile : string,
  edge   : boolean,
  chrome : boolean,
  firefox: boolean,
  safari : boolean,
  vivaldi: boolean,
  ie     : boolean,
  opera  : boolean
};

export type BDUUIDData = {
  bd_visitor_id: string
}